import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import { ReactComponent as Takephoto } from "../../../Assets/img/Kyc/svg/Takephoto.svg";
import { Button, Dialog, InputAdornment, TextField } from "@mui/material";
import { ReactComponent as Addto } from "../../../Assets/img/Kyc/svg/addto.svg";
import { ReactComponent as Successmsg } from "../../../Assets/img/Kyc/svg/successmsg.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Verify } from "../../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as NonVerify } from "../../../Assets/img/icons/Verified-icon-new.svg";
import "../../../Assets/css/kyc.css";

const VerifyBirthday = () => {
  const [showData, setShowData] = useState(true);
  const [show, setShow] = useState(false);
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [verifiedOpen, setVerifiedOpen] = useState(false);
  const [fullName, setFullName] = useState("");
  const [dob, setDob] = useState("");
  const [birthPlace, setBirthPlace] = useState("");
  const [parent1, setParent1] = useState("");
  const [parent2, setParent2] = useState("");
  const [register, setRegister] = useState("");
  const [masking, setMasking] = useState("");
  const [verify, setVerify] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true); // Set dragging state
  };

  const handleDragLeave = () => {
    setIsDragging(false); // Reset dragging state when leaving
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files; // Access dropped files
    handleFileChange({ target: { files } }); // Pass files to the handler
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Only handle one file
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setImagePreview(event.target.result);
        // Set the image preview to the FileReader result
      };
      reader.readAsDataURL(file);
      console.log("Image preview", imagePreview);
      // Read the file as a data URL for preview
    } else {
      console.log("Please upload a valid image file.");
    }
  };

  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const navigate = useNavigate();

  const maskingFunction = (number) => {
    if (number <= 4) {
      return number;
    }
    return number.slice(-3).padStart(number.length, "*");
  };
  const handleMasking = (e) => {
    const input = e.target.value;
    setRegister(input);
    const masking = maskingFunction(input);
    setMasking(masking);
  };

  const handleClose = () => {
    // setOpen(false);
    setShowData(false);
    setShowAddBtn(false);
    setVerifiedOpen(false);
  };

  const [file, setFile] = useState(null);
  const [fileURL, setFileURL] = useState("");

  return (
    <div className="Allcards_full_container p-3">
      <div className=" rounded-2 bg-white p-2">
        <div className=" d-flex flex-column align-items-center justify-content-center m-4">
          <h2 className="m-0">Verify Your Birth Certificate Identity</h2>
          <p className="paragraph m-0">
            Upload Your Birth Certificate for Secure Verification
          </p>

          <div className="d-flex justify-content-center">
            <div>
              {!fileURL && (
                <>
                  {imagePreview ? (
                    ""
                  ) : (
                    <>
                      <div
                        // className={`file-upload-container ${
                        //   isDragging ? "dragging" : ""
                        // }`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                      >
                        <input
                          type="file"
                          accept="image/*,.pdf"
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                          id="file-input"
                        />

                        <label
                          htmlFor="file-input"
                          className="button rounde-2 d-flex flex-column align-items-center justify-content-center m-3"
                        >
                          <Cloud width={80} />
                          <span className="m-0 p-0">
                            {isDragging
                              ? "Drop file here"
                              : "Drag file here or "}
                            <span className="text-primary">Upload File</span>
                          </span>
                          <p>5MB max file size</p>
                        </label>
                      </div>
                    </>
                  )}

                  {imagePreview && (
                    <div className="selectedImage">
                      <img
                        src={imagePreview}
                        alt="Uploaded"
                        style={{ maxWidth: "300px", marginTop: "20px" }}
                      />
                    </div>
                  )}
                </>
              )}

              {fileURL && (
                <div className="selectedImage">
                  {file && file.type.startsWith("image/") && (
                    <img
                      src={fileURL}
                      alt="Selected"
                      className="importImg"
                      style={{
                        marginTop: "10px",
                        // maxWidth: "300px",
                        // maxHeight: "300px",
                        padding: "20px",
                        width: "100px",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                  )}
                  {file && file.type === "application/pdf" && (
                    <iframe
                      src={fileURL}
                      title="Selected PDF"
                      style={{
                        marginTop: "10px",
                        width: "100%",
                        height: "500px",
                      }}
                    />
                  )}
                </div>
              )}
              {file && file.type === "application/pdf" && (
                <iframe
                  src={fileURL}
                  title="Selected PDF"
                  style={{ marginTop: "10px", width: "100%", height: "500px" }}
                />
              )}
            </div>
            {!imagePreview && (
              <>
                <Button className="button rounded-2 d-flex flex-column align-items-center justify-content-center m-3">
                  <Takephoto />
                  <p className="custom-text-color text-capitalize">
                    Capture Image
                  </p>
                </Button>
              </>
            )}
          </div>

          {showData && (
            <p className="paragraph">
              Please upload a clear image of your birth certificate to begin the
              verification process. Our system will<br></br> automatically
              detect and display your birth details. Alternatively, you can
              manually enter the details below.
            </p>
          )}
          <TextField
            inputRef={inputRef}
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            label="Full Name"
            style={{ width: "27vw" }}
            className="m-2"
          />
          <TextField
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            label="Date of Bitrh"
            type="date"
            className="m-2"
            style={{ width: "27vw" }}
            InputLabelProps={{
              shrink: true, // This forces the label to stay shrunk even when the field is empty
            }}
          />
          <TextField
            value={birthPlace}
            onChange={(e) => setBirthPlace(e.target.value)}
            label="Place of Birth*"
            className="m-2"
            style={{ width: "27vw" }}
          />
          <div>
            <div className="d-flex align-items-center">
              <TextField
                value={parent1}
                onChange={(e) => setParent1(e.target.value)}
                label={
                  show ? "Parent1/ Guardian Name*" : "Parent/ Guardian Name*"
                }
                className="m-2"
                style={{ width: "27vw" }}
              />
              {showAddBtn && <Addto onClick={() => setShow(true)} />}
              {/* Trigger the display of second TextField */}
            </div>

            {show /* Conditional rendering based on `show` state */ && (
              <TextField
                value={parent2}
                onChange={(e) => setParent2(e.target.value)}
                label="Parent 2/ Guardian Name*"
                className="m-2"
                style={{ width: "27vw" }}
              />
            )}
          </div>
          {showAddBtn && (
            <p>Click 'Add' to include Parent 2 or Guardian's name.</p>
          )}

          {!showData ? (
            <div className="d-flex flex-row align-items-center">
              <TextField
                value={masking}
                label="Register Number*"
                className="m-2"
                style={{ width: "27vw" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {verify ? <Verify /> : <NonVerify />}
                    </InputAdornment>
                  ),
                }}
              />

              {/* <div className="verify d-flex align-items-center">
            {verify ? <Verify /> : <NonVerify />}
          </div> */}
            </div>
          ) : (
            <TextField
              value={register}
              onChange={handleMasking}
              label="Register Number*"
              className="m-2"
              style={{ width: "27vw" }}
            />
          )}
          {!showData && (
            <p className="paragraph ">
              Thank You for Verifying Your Birth Certificate. Your identity has
              been securely confirmed. You can now proceed to <br />
              the next steps or return to your dashboard to explore other
              features.
            </p>
          )}
          {showData ? (
            <>
              <div className="d-flex flex-row">
                <Button
                  // variant="contained"
                  className=" txtcolor m-3"
                  //   onClick={() => setOpen(true)}
                >
                  Cancle
                </Button>
                <Button
                  variant="contained"
                  className=" btncolor m-3"
                  onClick={() => setVerifiedOpen(true)}
                >
                  Confirm
                </Button>
              </div>
            </>
          ) : (
            <Button
              variant="contained"
              className=" btncolor m-3"
              onClick={() =>
                navigate("/countrySelecting", {
                  state: {
                    SelectedCountry: {
                      label: "Singapore",
                      code: "SG",
                      phone: "65",
                    },
                  }, // Pass the selected country object
                })
              }
            >
              Back to KYC
            </Button>
          )}
          <Dialog open={verifiedOpen} onClose={() => setVerifiedOpen(false)}>
            <div className=" m-4 p-2 align-items-center justify-content-center text-center">
              <Successmsg />
              <div className="align-items-center justify-content-center text-center">
                <h6 className="fw-bold">Verification Successful!</h6>
                <p>Your Passport Details has been successfully verified.</p>
              </div>
              {/* <DialogContentText></DialogContentText> */}
            </div>
            <div className=" d-flex justify-content-center m-3">
              <Button
                variant="contained"
                className="btncolor"
                onClick={() => handleClose()}
              >
                continue
              </Button>
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
};
export default VerifyBirthday;
